import Toastr from '../../../components/Toastr'

const parent = 'INVENTORY_'
const DEFAULT_STATE = {
  transfers: [],
  transfer: {},
  meta: { pagination: {} },
  editing: false,
  saving: false,
}

export default function transferReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case `${parent}TRANSFERS_LOAD_PENDING`:
    case `${parent}TRANSFER_LOAD_PENDING`:
    case `${parent}TRANSFERS_HISTORY_LOAD_PENDING`:
      return { ...state, saving: false }

    case `${parent}TRANSFER_CREATE_PENDING`:
    case `${parent}TRANSFER_UPDATE_PENDING`:
      return { ...state, saving: true }

    case `${parent}TRANSFERS_LOAD_REJECTED`:
    case `${parent}TRANSFER_LOAD_REJECTED`:
    case `${parent}TRANSFER_CREATE_REJECTED`:
    case `${parent}TRANSFER_UPDATE_REJECTED`:
    case `${parent}TRANSFER_DELETE_REJECTED`:
    case `${parent}TRANSFERS_HISTORY_LOAD_REJECTED`:
      Toastr.handleShow(response?.data?.success, response?.data?.error, response?.status_code)
      return { ...state, saving: false }

    case `${parent}TRANSFERS_LOAD_FULFILLED`:
    case `${parent}TRANSFERS_HISTORY_LOAD_FULFILLED`:
      return {
        ...state,
        transfers: response.transfers || [],
        meta: response.meta || { pagination: {} },
        saving: false,
      }

    case `${parent}TRANSFER_LOAD_FULFILLED`:
      return {
        ...state,
        transfer: response.transfer || {},
        saving: false,
      }

    case `${parent}TRANSFER_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta?.message, 201)
      return {
        ...state,
        transfers: [...state.transfers, response.transfer],
        editing: false,
        transfer: {},
        saving: false,
      }

    case `${parent}TRANSFER_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta?.message, 201)
      return {
        ...state,
        transfers: state.transfers.map(item => item.id === response.transfer.id ? response.transfer : item),
        editing: false,
        transfer: {},
        saving: false,
      }

    case `${parent}TRANSFER_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta?.message || 'Transfer deleted successfully', 201)
      return {
        ...state,
        transfers: state.transfers.filter(item => item.id !== response.id),
        editing: false,
        transfer: {},
      }

    case `${parent}TRANSFER_EDIT`:
      return {
        ...state,
        editing: { id: action.id },
        transfer: action.id === 'New'
          ? { status: 'draft', stores: [{ store_id: '', note: '', items: [{ frame_id: '', quantity: 1 }] }] }
          : state.transfer,
      }

    case `${parent}TRANSFER_EDIT_CANCEL`:
      return {
        ...state,
        editing: false,
        transfer: DEFAULT_STATE.transfer,
      }

    default:
      return state
  }
}
